/* eslint-disable parog-web/no-glint-expect-error-directive */
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import ChemotherapySection from 'parog-web/components/treatment-history/edition-form/chemotherapy-section';
import HormonotherapySection from 'parog-web/components/treatment-history/edition-form/hormonotherapy-section';
import ImmunotherapySection from 'parog-web/components/treatment-history/edition-form/immunotherapy-section';
import OncologySection from 'parog-web/components/treatment-history/edition-form/oncology-section';
import OtherFollowUpEventsSection from 'parog-web/components/treatment-history/edition-form/other-follow-up-events-section';
import RadiotherapySection from 'parog-web/components/treatment-history/edition-form/radiotherapy-section';
import SurgerySection from 'parog-web/components/treatment-history/edition-form/surgery-section';
import TargetedTherapySection from 'parog-web/components/treatment-history/edition-form/targeted-therapy-section';
import TreatmentHistoryChangedJournalEvent from 'parog-web/models/treatment-history-changed-journal-event';

export default class TreatmentHistoryEditionFormComponent extends CrudJournalEventBaseComponent {
  static override forcDisplayName = 'Historique des traitements';
  static override fullComponentId = 'treatment-history/edition-form';
  static override journalEventClass = TreatmentHistoryChangedJournalEvent;

  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;

  override get model() {
    if (this.isNewMode) {
      const attrs = {
        surgerySurgeries: [],
        chemotherapies: [],
        oncologies: [],
        radiotherapies: [],
        immunotherapies: [],
        targetedTherapies: [],
        hormonotherapies: [],
        otherFollowUpEvents: [],
        protocols: []
      };

      return this.store.createRecord(
        'treatment-history-changed-journal-event',
        {
          occurredAt: new Date(),
          ...attrs
        }
      );
    }

    return this.retrievedJournalEvent as TreatmentHistoryChangedJournalEvent;
  }

  override async save(): Promise<TreatmentHistoryChangedJournalEvent> {
    const je = await super.save();
    await je.clearAndFetchAssociatedTaskAndConsultation();
    return je;
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <SurgerySection
          {{! @glint-expect-error }}
          @form={{Form}}
          @changeset={{this.changeset}}
          @followUpReasonId={{@patient.followUpReasonId}}
        />

        <OncologySection @form={{Form}} @changeset={{this.changeset}} />

        <ChemotherapySection
          {{! @glint-expect-error }}
          @form={{Form}}
          @changeset={{this.changeset}}
          @followUpReasonId={{@patient.followUpReasonId}}
        />

        <RadiotherapySection
          {{! @glint-expect-error }}
          @form={{Form}}
          @changeset={{this.changeset}}
          @followUpReasonId={{@patient.followUpReasonId}}
        />

        <ImmunotherapySection
          {{! @glint-expect-error }}
          @form={{Form}}
          @changeset={{this.changeset}}
          @followUpReasonId={{@patient.followUpReasonId}}
        />

        <TargetedTherapySection
          {{! @glint-expect-error }}
          @form={{Form}}
          @changeset={{this.changeset}}
          @followUpReasonId={{@patient.followUpReasonId}}
        />

        {{! @glint-expect-error }}
        <HormonotherapySection @form={{Form}} @changeset={{this.changeset}} />

        <OtherFollowUpEventsSection
          {{! @glint-expect-error }}
          @form={{Form}}
          @changeset={{this.changeset}}
        />

        <h2 class='ui dividing header'>Autres informations</h2>
        <div class='field'>
          <Form.TextArea @propertyName='comments' />
        </div>

      </:content>
    </Provider>
  </template>
}
